module.exports = __webpack_public_path__ + "static/headshot-rob-fry-2x.715fa826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-rob-fry-2x.jpg
// module id = 138
// module chunks = 35783957827783 152909308826437